var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('router-link',{staticStyle:{"float":"right"},attrs:{"to":"/overview"}},[_vm._v("go back")]),_c('Countdown',{attrs:{"timerDuration":_vm.timerDuration}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }